import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HolidayRegionCode } from '@wilson/interfaces';
import { GetPublicHolidayPipe } from '@wilson/organizational-unit';
import {
  GanttDayLeftPipe,
  GanttDayRightPipe,
  GanttDimensionDataSourceService,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { DateFnsModule } from 'ngx-date-fns';
import { map, Observable } from 'rxjs';
import { FindStaffGanttChartService } from '../services/find-staff-gantt-chart.service';
import { Store } from '@ngxs/store';
import { ShiftAssignmentModalState } from '@wilson/shift-timeline/state';
import { eachDayOfInterval } from 'date-fns';

@Component({
  selector: 'wilson-timeline-modal-header',
  templateUrl: './timeline-modal-header.component.html',
  styleUrls: ['./timeline-modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslatePipe,
    GetPublicHolidayPipe,
    GanttDayLeftPipe,
    GanttDayRightPipe,
    DateFnsModule,
    NzTooltipModule,
    NzTagModule,
  ],
})
export class TimelineModalHeaderComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly findStaffGanttChartService = inject(
    FindStaffGanttChartService,
  );
  private readonly ganttDimensionDataSourceService = inject(
    GanttDimensionDataSourceService,
  );

  hoursRange$!: Observable<string[]>;
  daysRange$!: Observable<Date[]>;
  public resourcesColumnWidthPx$!: Observable<number>;
  public frameLength$!: Observable<number>;
  publicHolidaysRegion$!: Observable<HolidayRegionCode | undefined>;

  @Input()
  stickyHasShadow?: boolean;

  async ngOnInit(): Promise<void> {
    this.daysRange$ = this.ganttDimensionDataSourceService
      .visibleDaysRangeStream()
      .pipe(map((timeframe) => eachDayOfInterval(timeframe)));
    this.frameLength$ =
      this.ganttDimensionDataSourceService.frameLengthStream();
    this.hoursRange$ = this.findStaffGanttChartService.hoursRange$;
    this.resourcesColumnWidthPx$ = this.store.select(
      ShiftAssignmentModalState.resourcesColumnWidthPx,
    );
    this.publicHolidaysRegion$ =
      this.findStaffGanttChartService.publicHolidaysRegion$;
  }
}
